import { CartaCreditoFinanceiro } from './carta-credito-financeiro.model';
import { Moment } from 'moment';
import { ComposicaoRda } from './composicao-rda.model';

export class CartaCreditoFinanceiroGerada {

  id: number;
  cartaCredito: CartaCreditoFinanceiro;
  composicaoRda: ComposicaoRda;
  dataGeracao: Moment;
  idArquivoCarta: string;
  numeroCarta: string;
  enviadoSei: boolean;;
  numeroRecibo: string;
  idArquivoRecibo: string
  idUnicoPessoaGerou: number
  idMomentoPessoaGerou: number

}
